"use strict";

define('config/validation',['appkit/configurator', 'backbone-validation'], function (Configurator, Validation) {
  var ValidationConfigurator = Configurator.extend({
    onConfigure: function onConfigure() {
      Validation.configure({
        labelFormatter: 'label'
      });
    }
  });
  return ValidationConfigurator;
});

